import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=08b44f7c&scoped=true&"
import script from "./ArticleView.vue?vue&type=script&lang=js&"
export * from "./ArticleView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleView.vue?vue&type=style&index=0&id=08b44f7c&prod&lang=css&"
import style1 from "./ArticleView.vue?vue&type=style&index=1&id=08b44f7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b44f7c",
  null
  
)

export default component.exports